import * as Popper from '@popperjs/core'
import * as Tippy from 'tippy.js'

export default {
  Popper,
  Tippy,
}
